import { ToastService } from 'ng-uikit-pro-standard';
import { ConfiguracionGeneralService } from './../admin.configuracion-general.module/service/configuracion-general.service';
import { ConfiguracionGeneralModel } from './../admin.configuracion-general.module/service/configuracion-general.model';
import {Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html'
})
export class MainPortalComponent implements OnInit {

  public classFont: string = '';
  public configuracion: ConfiguracionGeneralModel = {};
  public renderizado = false;

  constructor(private router: Router,
    private toastMsg: ToastService,
    private configuracionGeneralService: ConfiguracionGeneralService) {
    router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      (event.url === '/portal') ? this.classFont = 'font-contendiolp' : this.classFont = 'font-general';
    });
  }

  async ngOnInit() {
    localStorage.removeItem('configuracionGeneral');
    try {
      this.configuracion = await this.configuracionGeneralService.obtenerConfiguracionGeneral();
        const obj = {
          groupElements1: this.configuracion.groupElements1,
          groupElements2: this.configuracion.groupElements2,
          groupElements3: this.configuracion.groupElements3,
          groupElements4: this.configuracion.groupElements4,
          color1: this.configuracion.color1,
          color2: this.configuracion.color2,
          color3: this.configuracion.color3,
          color4: this.configuracion.color4,
          fuenteContenido: this.configuracion.fuenteGeneral,
          fuenteContenidoLP: this.configuracion.fuenteContenidoLP,
          fuenteSubtitulos: this.configuracion.fuenteSubtitulos,
          fuenteTitulos: this.configuracion.fuenteTitulos,
          beneficioTia: this.configuracion.beneficioTia,
          beneficioAv: this.configuracion.beneficioAv,
          beneficioTpv: this.configuracion.beneficioTpv,
          beneficioVisitante: this.configuracion.beneficioVisitante
        };
        this.renderizado = true;
        await localStorage.setItem('configuracionGeneral', JSON.stringify(obj));
    }catch(error) {
      this.toastMsg.error("Error al obtener configuración inicial, algunas funciones pueden no estar disponibles");
    }
  }
}

